import { experimental_extendTheme as extendTheme, CssVarsThemeOptions } from '@mui/material/styles';
import { BigidColorsV2, commonTheme } from '@bigid-ui/components';
import type {} from '@mui/material/themeCssVarsAugmentation';
import { BigidMeColorSchemesVars, BigidMeSchemeCustomVars } from '../assets/theme';
import { makeIllustrationColor } from '../utils';

export const createAppTheme = ({
  colors,
  fontFamily,
  customFont,
}: {
  colors?: BigidMeSchemeCustomVars;
  fontFamily?: string;
  customFont?: boolean;
}) => {
  return extendTheme({
    ...commonTheme,
    colorSchemes: {
      ...commonTheme.colorSchemes,
      light: {
        ...commonTheme.colorSchemes?.light,
        palette: {
          ...commonTheme.colorSchemes?.light?.palette,
          bigid: {
            ...commonTheme.colorSchemes?.light?.palette?.bigid,
            primary900: BigidColorsV2.gray[900],
            primary700: BigidColorsV2.gray[700],
            primary500: BigidColorsV2.gray[500],
            primary400: BigidColorsV2.gray[400],
            primary300: BigidColorsV2.gray[300],
            primary200: BigidColorsV2.gray[200],
            primary150: BigidColorsV2.gray[150],
            primary100: BigidColorsV2.gray[100],
            primary50: BigidColorsV2.gray[50],
          },
          bigidMe: {
            ...BigidMeColorSchemesVars.light, // can be removed soon
            ...(colors ? { ...colors, illustrationColor: makeIllustrationColor(colors.primary) } : {}),
          },
        },
        tokens: {
          bigid: {
            ...commonTheme.colorSchemes?.light?.tokens?.bigid,
            // Text & Icon colors
            foregroundCta: BigidColorsV2.gray[700],
            // Background colors
            backgroundActive: BigidColorsV2.gray[900],
            backgroundCta: BigidColorsV2.gray[700],
            backgroundActiveSubtle: BigidColorsV2.gray[200],
            backgroundHover: BigidColorsV2.gray[600],
            backgroundHoverSubtle: BigidColorsV2.gray[150],
            // Borders
            borderCta: `1px solid ${BigidColorsV2.gray[700]}`,
            // Semantic Colors
            insightStrong: BigidColorsV2.purple[900],
            insight: BigidColorsV2.purple[600],
            insightSubtle: BigidColorsV2.purple[100],
            // focus
            focusOutline: `1px auto ${BigidColorsV2.gray[500]}`,
          },
        },
      },
    },
    typography: {
      ...commonTheme.typography,
      fontFamily: fontFamily ? fontFamily : 'Mulish, Helvetica, Arial, sans-serif',
    },
    components: {
      ...commonTheme.components,
      MuiCssBaseline: {
        styleOverrides:
          customFont && fontFamily
            ? `
        @font-face {
          font-family: ${fontFamily};
          font-weight: 300;
          src: local(${fontFamily}), local('${fontFamily}-Light'), url('${process.env.PUBLIC_URL}/fonts/Custom1-Light.woff2') format('woff2');
        }
        @font-face {
          font-family: ${fontFamily};
          font-weight: 400;
          src: local(${fontFamily}), local('${fontFamily}-Regular'), url('${process.env.PUBLIC_URL}/fonts/Custom1-Regular.woff2') format('woff2');
        }
        @font-face {
          font-family: ${fontFamily};
          font-weight: 500;
          src: local(${fontFamily}), local('${fontFamily}-Medium'), url('${process.env.PUBLIC_URL}/fonts/Custom1-Medium.woff2') format('woff2');
        }
        @font-face {
          font-family: ${fontFamily};
          font-weight: 700;
          src: local(${fontFamily}), local('${fontFamily}-Bold'), url('${process.env.PUBLIC_URL}/fonts/Custom1-Bold.woff2') format('woff2');
        }
        @font-face {
          font-family: ${fontFamily};
          font-weight: 900;
          src: local(${fontFamily}), local('${fontFamily}-Black'), url('${process.env.PUBLIC_URL}/fonts/Custom1-Black.woff2') format('woff2');
        }
          body {
            background: #f6f6f6;
          }
      `
            : `
          body {
            background: #f6f6f6;
          }`,
      },
    },
  } as CssVarsThemeOptions);
};
